import React, { useState, useEffect } from "react";
import { Col, Container, Modal, Row, Button} from 'react-bootstrap';
import { useSelector } from "react-redux";
import APICom from '../../utils/helpers/APICom';


const VehicleTracking = (props) => {

    const { GlobalASCSData}  = useSelector((store) => store.combinedata);
    const { loginData } = useSelector((store) => store.login);
    const [showVehicleTrackingDialog, setShowVehicleTrackingDialog] = useState(false);
    const [displayNoDataAlert, setDisplayNoDataAlert] = useState(false);
    const [phone, setPhone] = useState('');
    const [trackingLink, setTrackingLink] = useState('');
   
    const [noDataAlert, setNoDataAlert] = useState({ alertTitle: '', alertMsg: '' });


    useEffect(() => {
        console.log("Vehicle Tracking invoked");
        const rowData = props.GridRowData;

        if (!rowData || rowData.length !== 1) {
            // No trip selected or multiple trips selected
            setNoDataAlert({
                alertTitle: !rowData ? 'No trip selected' : 'Multiple trips selected',
                alertMsg: !rowData ? 'Please select a trip to send a tracking message.' : 'Please select one trip to send a tracking message.'
            });
            setPhone('');
            setTrackingLink('');
            setDisplayNoDataAlert(true);
            setShowVehicleTrackingDialog(false);
        } else {
            const gData = rowData[0];
            const tripStatus = gData["TripRequestStatus"];
            
            if (!tripStatus || tripStatus.toUpperCase() === "NONE") {
                setNoDataAlert({
                    alertTitle: 'Invalid Trip Status',
                    alertMsg: 'Trip status is not valid for sending a tracking message'
                });
                setDisplayNoDataAlert(true);
                setShowVehicleTrackingDialog(false);
            } else {
                const customerPhone = gData["Phone"];
                const confirmationNo = gData["ConfirmationNo"] || "-1";
                let vehicleLink = "";
                const iOutloadTSPID = gData["iSRATSPID"] || "-1";
                let trackingURL = "";
                if (GlobalASCSData !== null && GlobalASCSData !== undefined) {
                    const jsonArray = GlobalASCSData;
                    const trackingItem = jsonArray.find(item => item.SubTitle === "MARSWebBookingURL_TripTracking");

                    if (trackingItem) {
                        vehicleLink = trackingItem.value;
                    }
                }

                if (vehicleLink !== "" && confirmationNo !== "" && iOutloadTSPID !== "") {
                    trackingURL = `${vehicleLink}/VehicleTracker.aspx?ConfirmationNo=${confirmationNo}&TspID=${iOutloadTSPID}`;
                }

                setPhone(customerPhone);
                setTrackingLink(trackingURL);
                setShowVehicleTrackingDialog(true);
            }
        }
    }, [props.GridRowData, GlobalASCSData]);
    
    const handleVehicleTrackingActionSendLink = async (e) => {
        try {
            const gData = props.GridRowData[0];
            let data = {
                "iServiceID": isNaN(gData["ServiceID"]) ? parseInt(gData["ServiceID"]) : gData["ServiceID"],
                "iManualAffiliateID": isNaN(gData["iSRATSPID"]) ? parseInt(gData["iSRATSPID"]) : gData["iSRATSPID"],
                "vPhoneNo": phone,
                "Msg": trackingLink,
                "iModifiedByUserID": isNaN(loginData.iUserID) ? parseInt(loginData.iUserID) : loginData.iUserID
            }
            let response = await APICom.fetchData("", "TripActions/SendManualMessageForVehTracking", "post", { "Content-Type": "application/json" }, data, null);
            let status = response.data["result"]
            setNoDataAlert({
                alertTitle: status === "true" ? 'Link Sent' : 'Link Not Sent',
                alertMsg: status === "true" ? 'Message is Sent Successfully' : '<essage is not Sent Successfully.Have Some Problem in Creating Pending API entry in DB'
            });
            setShowVehicleTrackingDialog(false);
            setDisplayNoDataAlert(true);
        }
        catch (err) { console.log(err); }
    }

    // Helper function to format the phone number
    const formatPhoneNumber = (input) => {
        const numericInput = input.replace(/\D/g, '');
        const formattedNumber = numericInput.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
        return formattedNumber;
    };

    // Handle changes in the phone number input
    const handlePhoneInputChange = (e) => {
        const inputValue = e.target.value;
        const formattedValue = formatPhoneNumber(inputValue);

        // Restrict the input to 12 characters
        if (formattedValue.length <= 12) {
            setPhone(formattedValue);
        }
    };

    const UnMountVehicleTrackingComponent = () => {
        if(props.showVehicleTracking)
          {
            props.setShowVehicleTracking(false);
          }
      }

    const handleVehicleTrackingDialogClose = () => {
        try {
            setShowVehicleTrackingDialog(false);
            props.setShowVehicleTracking(false);
            UnMountVehicleTrackingComponent();
        } catch (err) {
            console.log(err);
        }
    }


    const handleAlertModalClose = () => {
        setDisplayNoDataAlert(false);
        UnMountVehicleTrackingComponent();


    }
   

    return (
        <>
            {showVehicleTrackingDialog &&
                <Modal centered show={showVehicleTrackingDialog} onHide={handleVehicleTrackingDialogClose} backdrop="static" animation={true} keyboard={true}>
                    <Modal.Header className='activate_dialog_header_bgcolor' style={{ height: "50px" }} closeButton>
                        <Modal.Title className='activate_dialog_title_color user-select-none'>Send Tracker Link</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="grid-example">
                        <Container>
                            <Row>
                                <Col className="user-select-none" md={{ span: 4, offset: -1 }}>
                                    Customer Phone:
                                </Col>
                                <Col>
                                    <input 
                                        value={phone}
                                        onChange={handlePhoneInputChange}
                                        maxLength="12" 
                                        className="tracking-veh-input-wrapper"
                                        />
                                </Col>      
                            </Row>
                            <Row></Row>
                            <Row className="row_gap_generic">
                                <Col className="user-select-none" sm={{ span: 4, offset: -1 }}>
                                    Tracking Link:
                                </Col>
                                <Col>
                                    <textarea value={trackingLink} rows={5} readOnly={true} className="tracking-veh-input-wrapper"/>
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className="tripaction_btn_color" onClick={handleVehicleTrackingActionSendLink}>
                            Send Link
                        </Button>
                        <Button variant="secondary" onClick={handleVehicleTrackingDialogClose}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>}
            {displayNoDataAlert && <Modal centered show={displayNoDataAlert} onHide={handleAlertModalClose} animation={false}>
                <Modal.Header className='noshow_dialog_header_bgcolor' style={{ height: "50px" }} closeButton>
                    <Modal.Title className='noshow_dialog_title_color'>{noDataAlert.alertTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body><b>{noDataAlert.alertMsg}</b></Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleAlertModalClose}>
                        Ok
                    </Button>
                </Modal.Footer>
            </Modal>}
        </>

    );
}

export default VehicleTracking;